export function enable() {
    enableFilter();
}

export function enableFilter() {
    const filterForm = document.getElementById("filter-form") as HTMLFormElement;

    if (!filterForm) {
        console.error("Filter not found.");
        return;
    }

    const filterOptions = filterForm.querySelectorAll<HTMLElement>("input, select");

    filterOptions.forEach((element) => {
        element.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                filterForm.submit();
            }
        });
    });
}
